import {
  Box,
  Button,
  CircularProgress,
  DialogContent,
  Typography
} from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  activateClientStaffStatusAction,
  logoutClientStaffAction,
  resetClientStaffPasswordAction
} from 'src/store/actions/ClientManagerActions';
import PropTypes from 'prop-types';

const ConfirmationDialog = ({
  handleClose,
  message,
  rowData,
  title,
  isAdmin
}) => {
  const [loading, setLoading] = useState(false);
  const [extras, setExtras] = useState('');
  const disptach = useDispatch();

  const handleSubmit = async () => {
    setLoading(true);
    const filter = { issuerID: rowData?.issuerID, issuerStaffID: rowData?.id };
    let response = null;
    switch (title) {
      case 'reset-password': {
        response = await disptach(
          resetClientStaffPasswordAction(filter, isAdmin)
        );
        if (response.status == 1) {
          setExtras(response.message);
          setTimeout(() => {
            handleClose();
          }, 3000);
        }
        break;
      }
      case 'logout': {
        response = await disptach(logoutClientStaffAction(filter, isAdmin));
        if (response.status == 1) {
          handleClose();
        }
        break;
      }
      case 'activate': {
        const payload = {
          data: { accessStatus: rowData?.accessStatus === 1 ? 0 : 1 }
        };
        response = await disptach(
          activateClientStaffStatusAction(filter, isAdmin, payload)
        );
        if (response.status == 1) {
          handleClose();
        }
        break;
      }
      default:
        break;
    }
    setLoading(false);
  };

  return (
    <DialogContent>
      <Box marginY={2}>
        <Typography variant="h5" gutterBottom>
          {message}
        </Typography>
      </Box>
      <Box>
        {extras && (
          <Typography variant="body1" color="textSecondary" gutterBottom>
            {extras}
          </Typography>
        )}
      </Box>
      <Box>
        <Button variant="outlined" onClick={handleClose}>
          Close
        </Button>
        &nbsp;
        <Button
          disabled={loading}
          variant="contained"
          color="primary"
          onClick={() => handleSubmit()}
        >
          {loading && <CircularProgress size="1.5rem" />}
          Submit
        </Button>
      </Box>
    </DialogContent>
  );
};

ConfirmationDialog.propTypes = {
  handleClose: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  rowData: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool.isRequired
};

export default ConfirmationDialog;
